import { render } from "./PanelPublicistaEvolucion.vue?vue&type=template&id=4f15c4a0&scoped=true"
import script from "./PanelPublicistaEvolucion.vue?vue&type=script&lang=js"
export * from "./PanelPublicistaEvolucion.vue?vue&type=script&lang=js"

import "./PanelPublicistaEvolucion.vue?vue&type=style&index=0&id=4f15c4a0&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f15c4a0"]])

export default __exports__